import { TypographyH4 } from "@/components/typography/H4";
import { TypographySM } from "@/components/typography/SM";
import { Button } from "@/components/ui/button";
import { CreateSubscriptionOfferForm } from "@/features/create-subscription-offer-form";
import { requireAdmin } from "@/lib/tanstack-router/requireAdmin";
import { Link, createFileRoute } from "@tanstack/react-router";
import { ArrowLeftCircle, BookMarked, ExternalLink } from "lucide-react";

export const Route = createFileRoute(
  "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/create-subscription-offer"
)({
  component: requireAdmin(CreateSubscriptionOffer)
});

function CreateSubscriptionOffer() {
  return (
    <div className="grid grid-cols-2 gap-x-20 gap-y-16 h-full place-content-center">
      <Link
        to="/organization/$organizationSlug/subscriptions"
        params={(prev) => ({ organizationSlug: prev.organizationSlug || "" })}
        search={{ view: "subscription-offers" }}
      >
        <Button
          variant="outline"
          size="sm"
          className="place-self-start dark:text-brand-gray-300 hover:dark:text-brand-gray-100"
        >
          <ArrowLeftCircle className="w-4 h-4 inline mr-2" />
          Back
        </Button>
      </Link>
      <div className="row-start-2">
        <CreateSubscriptionOfferForm />
      </div>
      <div className="row-start-2 rounded border dark:border-brand-gray-800 h-fit mt-24 p-6 grid grid-cols-[35px_1fr] gap-y-3 items-center">
        <BookMarked
          className="h-6 w-6 dark:text-brand-gray-600"
          strokeWidth="1.6"
        />
        <TypographyH4 className="col-start-2">Subscription offers</TypographyH4>
        <TypographySM className="col-start-2 row-start-2 dark:text-brand-gray-400">
          Subscription offers let you share access to your apps with other
          organizations. Once accepted, members of the subscribing organization
          will be able to use your app. App administrators will be able to see
          all subscribers of their app.
          <br />
          <br />
          Subscriptions can be withdrawn at any time by the app administrator or
          cancelled by the subscribing organization.
        </TypographySM>
        <a
          href="https://www.numerous.com/docs"
          className="col-start-2 row-start-3 place-self-end"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button variant="ghost">
            Read more
            <ExternalLink className="w-4 h-4 ml-2 inline" />
          </Button>
        </a>
      </div>
    </div>
  );
}
